import Flickity from './Flickity';

const sliderConfig = {
  prevNextButtons: false,
  adaptiveHeight: false,
  draggable: false,
};

export default class MicrositeEvents {
  constructor(element) {
    this.element = element;

    // Exit if we don't have more than one slide.
    if (!this.shouldBuildSlider) return;

    // Build Slider
    this.buildSlider();

    // Move content into containers
    this.createContainers();
  }

  createContainers() {
    const viewsRowsNodes = this.element.querySelectorAll('.node');
    viewsRowsNodes.forEach((node) => {
      node.classList.add('node-home-event');
      node.classList.remove('no-more');

      const imageDateWrap = document.createElement('div');
      imageDateWrap.classList.add('image-date-wrap');

      const contentWrap = document.createElement('div');
      contentWrap.classList.add('content-wrap');

      const nodeUpperMeta = node.querySelector('.node-upper-meta');
      const nodeImage = node.querySelector('.node-image');
      const nodeUpperImage = node.querySelector('.node-upper-image');
      const nodeInner = node.querySelector('.node-inner');

      if (nodeUpperMeta) {
        imageDateWrap.appendChild(nodeUpperMeta);
      }

      // if (nodeImage) {
      //   imageDateWrap.appendChild(nodeImage);
      // }

      if (nodeUpperImage) {
        imageDateWrap.appendChild(nodeUpperImage);
      } else {
        imageDateWrap.appendChild(nodeImage);
      }

      if (nodeInner) {
        contentWrap.appendChild(nodeInner);
      }

      node.appendChild(imageDateWrap);
      node.appendChild(contentWrap);
    });
  }

  buildSlider() {
    this.slider = new Flickity(this.sliderElement, sliderConfig);
  }

  get shouldBuildSlider() {
    return this.slides.length > 1;
  }

  get sliderElement() {
    return this.element.querySelector('.view-content');
  }

  get slides() {
    return this.sliderElement.childNodes;
  }
}
